export default __webpack_public_path__ + "static/media/ru.a91fc3e7.jpg";